import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { BreakItem } from "../../pages/Simulcast/components/AdSystemInfo/types";

interface BreakStore {
    breaks: BreakItem | null;
    breaksArray: BreakItem[];
    position: number;
    hasSlate: boolean;
    setBreak: (breakItem: BreakItem) => void;
    setPosition: (position: number | undefined) => void;
    getPosition: () => number;
    getBreak: () => BreakItem | null;
    setBreaksArray: (breakItems: BreakItem[]) => void;
    getBreaksArray: () => BreakItem[];
    getBreakById: (id: string) => BreakItem | undefined;
    getHasSlate: () => boolean;
    setHasSlate: (hasSlate: boolean) => void;
    clearBreaks: () => void;
}

const useBreaksStore = create(
    persist<BreakStore>(
        (set, get) => ({
            breaks: null,
            breaksArray: [],
            position: 0,
            hasSlate: false,
            setBreak: (breakItem) => {set({ breaks: breakItem })},
            setPosition: (local) => set({position: local}),
            getPosition: () => get().position,
            getBreak: () => get().breaks,
            setBreaksArray: (breakItems) => set({ breaksArray: breakItems }),
            getBreaksArray: () => get().breaksArray,
            getBreakById: (id) => get().breaksArray.find(breakItem => breakItem.id === id),
            clearBreaks: () => set({ breaks: null, breaksArray: [] }),
            getHasSlate: () => get().hasSlate,
            setHasSlate: (hasSlate) => set({hasSlate: hasSlate}),
        }),
        {
            name: "breaks-storage",
            storage: createJSONStorage(() => localStorage), 
            version: 1, 
        }
    )
);


export default useBreaksStore;